import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img from '../assets/others/11102057.png'
import img1 from '../assets/others/11102058.jpg'
import img2 from '../assets/others/11102059.jpg'
import img3 from '../assets/others/11102060.png'
import img4 from '../assets/others/11102061.jpg'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import Corefeature from '../Components/Corefeature/Corefeature'
import { Helmet } from 'react-helmet-async'
library.add(fas)

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  const sliderImageUrl = [
  //First image url
  {
      url:img,
      src:'',
      caption: 'Analog Layout Design'
  },
  {
      url:img2,
      caption: 'Analog Circuit Design'
  },
  {
      url:img,
      caption: 'Physical Design'
  },
  {
      url:img2,
      caption: 'ASIC Design'
  },
  {
      url:img,
      caption: 'Design For Test'
  },
 
];
  

const Coursevideos = () => {
  return (
        <div>
          <Helmet>
      <title>Free VLSI Course Videos & Tutorials to Watch | Takshila VLSI</title>
      <meta name="description" content="Explore free VLSI course videos and tutorials covering Physical Design, DFT, and Verification to start your semiconductor learning journey with Takshila VLSI." />
      <link rel="canonical" href="https://www.takshila-vlsi.com/course-videos/" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Free VLSI Course Videos & Tutorials to Watch | Takshila VLSI" />
      <meta property="og:description" content="Explore free VLSI course videos and tutorials covering Physical Design, DFT, and Verification to start your semiconductor learning journey with Takshila VLSI." />
      <meta property="og:url" content="https://www.takshila-vlsi.com/course-videos/" />
      <meta property="og:site_name" content="Takshila VLSI" />
      <meta property="article:modified_time" content="2024-07-10T15:06:21+00:00" />
      <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Header/>
      <main>
        <section className='section-banner pg-banner mb-5'>
            <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md p-lg-5 p-4">
                                <div class="pg-title-sec">
                                    <h1 className='pg-title pb-3'>Your gateway to knowledge on demand. Unlocking learning anytime, anywhere.</h1>
                                   </div>
                              </div>
                          </div>
                
                <div className="carouselvideo">
                   
                     <Carousel responsive={responsive} arrows={false} showDots={true} autoPlay={true} 
                            >
                            {sliderImageUrl.map((imageUrl, index) => {
                                                                return (
                                                                  <div className="slider" key={index}>
                                                                    <div class="video-box">
                                                                      <div className='thumb-img'>
                                                                      <img src={imageUrl.url} alt="movie" />
                                                                      </div>
                                                                      <div className='box-content dark-bg d-flex'>
                                                                        <div className='box-ctn-top'>
                                                                      <a href="https://elearn.takshila-vlsi.com/" target="_blank">
                                                                      <FontAwesomeIcon icon="fa-solid fa-circle-play" /></a>
                                                                      <h3 className='course-head'>{imageUrl.caption}</h3>
                                                                      </div>
                                                                      <div className='box-ctn-bottom'>
                                                                        <a href="https://elearn.takshila-vlsi.com/" target="_blank">
                                                                      <button className='btn-primary btn-icon ms-0'>Visit Our Learning Plartform</button>
                                                                      </a>
                                                                      </div>
                                                                      </div>
                                                                    </div>
                                                                    
                                                                  </div>
                                                                );
                                                              })}
                            
                            
                            </Carousel>
                          
                </div>
                </div>
                </section>
          <section className='ws-section pb-5'>
          <div class="container text-center">
              <div class="row">
                <div class="col-lg align-self-start">
                <h2 class="ws-section_heading pd-03">How it works?</h2>
                </div>
                </div>
                <div class="row">
                <div class="col-lg img-radius">
                     <img src={img3} alt=''/>
                 </div>
              </div>
            </div>
          </section>
          <Corefeature/>
          <section className='p-lg-5'>
            <div class="container text-center">
              <div class="row">
                <div class="col-lg">
                <h2 class="ws-section_heading mb-3 txt-3"><span class="font-thin">Navigate your path to</span><br/> getting the dream VLSI job</h2>
                <p class="ws-section_sub-heading text-lg">Fill out the form below and avail free access to best recruiters leading the semiconductor industry</p>
                </div>
              </div>
              </div>
            </section>
            <section className='connect-section ws-section pb-5'>
          <div className='container'>
          <div class="row">
                <div class="col-lg img-radius">
                <img src={img4} alt=''/>
                </div>
                <div class="col-lg ml--10 mt-5">
                  <div className='ctn-frm'>
                  <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="600"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/Contact1/formperma/N-2pG_vejEdFn5YV0bRYfNbavyMoa_esY9D_jQDpa28`}
                                    frameborder="0" 
                                    title='Register Now'
                                   
                                />
 </div>
                </div>
                
            </div>
            </div>
          </section>
                </main>
      <Enrollaction/>
      <Partnersec/> 
      <Footer/>
  </div>
  )
}

export default Coursevideos